<div class="page">
  <div class="header">
    <button mat-icon-button class="header-button" type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h1>Vista previa de receta</h1>
  </div>

  <mat-dialog-content class="preview-content">
    <iframe [src]="pdfUrl" title="Vista previa de receta"></iframe>
  </mat-dialog-content>
</div>
